import React, { Component, Modal } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { FETCH_EVENTS, EVENTS_SET_ACTIVE, BET_SELECT, USER_FETCH_BETS, MODAL_USER_PROMPT_LOGIN, MODAL_SHOW } from '../../constants/action-types';
import EventCard from './event/widgets/EventCard';

class UsersBetsComponent extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {

        this.props.getBets()
        if (!firebase.auth().currentUser)

            this.props.showLoginModal()
        
        
        this.props.getEvents()

    }


    render() {
        //new Date(b.eventDate).toLocaleDateString('en-US', { month: 'numeric', day: '2-digit', hour: 'numeric', minute: '2-digit' })

        return (
            <section id='bets' className='content-section-wrap'>
                <div id='bets-head' className='content-section-head'>
                    <h1 className='mvu-head xl'>Your bets</h1>
                  
                    <div className='mvu-status' style={{display:'inline-block'}}>                    
                        <p>
                            <small># BETS MADE</small> {this.props.user.bets.length} <br />
                            <small># BETS WON</small> {this.props.user.userStats.bets_won}<br />
                            <small># BOUNTY POINTS</small> {this.props.user.userStats.bounty_points}
                        </p>
                    </div>

                </div>
                <div id='bets-list-wrap' className='content-section'>
                    {this.props.user.betsError ? (
                        <div className='error'>
                            <div>Error information: {this.props.user.betsError}</div>
                        </div>
                    ) : null}
                    {(this.props.user.bets.length === 0 && !this.props.user.betsLoading) ? (
                        <div className='content-section-empty'>
                            <h1>No bets found</h1>
                        </div>
                    ) : null}
                    {this.props.user.betsLoading ? (
                        <div className='content-section-empty'>
                            <h1>Loading</h1>
                        </div>)
                        : null}
                    {
                        this.props.user.bets.length !== 0 && !this.props.user.betsLoading ? (
                            <ul>
                                {this.props.user.bets.map((b, i) => (
                                    <li className='event-wrap'>
                                        <Link to={`/events/${b.eventId}`} key={i.toString()}>
                                            {/* The fact that we have to do this shows the API response was structured incorrectly */}
                                            <EventCard className='event-details-top' event={new Object({
                                                team_one_name: b.teamOne,
                                                team_two_name: b.teamTwo,
                                                eventId: b.eventId,
                                                userPick: b.userPick,
                                                status: b.status,
                                                event: this.props.events.events && this.props.events.events[this.props.events.events.map(e => e.id).indexOf(b.eventId)],
                                                startTimeLocal: new Date(b.eventDate * 1000).toLocaleDateString()
                                            })} minified={true} key={i.toString()}></EventCard>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        ) : null
                    }
                </div>
            </section>
        );

    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
    showLoginModal: () => dispatch({ type: MODAL_SHOW, modal: MODAL_USER_PROMPT_LOGIN }),
    getEvents: () => dispatch({ type: FETCH_EVENTS }),
    getBets: () => dispatch({ type: USER_FETCH_BETS })
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UsersBetsComponent)


// WEBPACK FOOTER //
// ./src/components/general/Bets.js